import {request} from './../request.js'
import AppConfig from '../../../config/AppConfig.js'

// 根据客服id，获取客服信息数据
export function webGetCustomById(id,callback){
	request({
			method: 'post',
			url: 'custom/getById',
			data: {
			  id: id
			}
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 根据客服id，获取客服信息数据
export function webUpdateCustomByWxId(data,callback){
	request({
			method: 'post',
			url: 'custom/updateByWxId',
			data: data
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 判断是否能同步
export function canSync(phone_id,callback){
	request({
			method: 'post',
			url: 'custom/canSync',
			data: {
				phone_id: phone_id
			}
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}